import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import LayoutContext from '../LayoutContext';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  toggleHandler:{
    "-webkit-app-region":"no-drag",
    "-webkit-user-select": "none"
  }
}));

const SidebarToggleHandler = ({ children, ...restProps }) => {
  const { isSidebarOpen, setSidebarOpen } = useContext(LayoutContext);
  const classes = useStyles();

  return (
    <IconButton className={`Cmt-toggle-menu ${classes.toggleHandler}`} onClick={() => setSidebarOpen(!isSidebarOpen)} {...restProps}>
      {children || <MenuIcon />}
    </IconButton>
  );
};

export default SidebarToggleHandler;
